import { createFileRoute } from "@tanstack/react-router";
import CollaboratorAcceptPage from "@/pages/CollaboratorAcceptPage";

export const Route = createFileRoute("/collaborator-accept")({
  component: CollaboratorAcceptPage,
});
